import React from 'react';
import { getCategoryName } from '../utils/bruto';

// Category name -> chip classes (token pairs). Exported so other screens can reuse it.
export const CATEGORY_CHIP_CLASSES = {
  'Creative Concept': 'bg-cat-concept-bg text-cat-concept-fg',
  'Creative Design': 'bg-cat-design-bg text-cat-design-fg',
  '3D Modeling': 'bg-cat-three-bg text-cat-three-fg',
  Updates: 'bg-cat-updates-bg text-cat-updates-fg',
  Preparation: 'bg-cat-prep-bg text-cat-prep-fg',
};

export const categoryChipClass = (name) => CATEGORY_CHIP_CLASSES[name] || 'bg-surface-alt text-muted';

// Category name as a coloured chip with the task label in muted text underneath.
export default function CategoryCell({ entry }) {
  const name = getCategoryName(entry.category);
  return (
    <div>
      <span className={`inline-block text-[11.5px] font-medium rounded-full px-2.5 py-1 ${categoryChipClass(name)}`}>{name}</span>
      {entry.task_label && (
        <div className="text-[11.5px] text-muted mt-1.5">{entry.task_label}</div>
      )}
    </div>
  );
}
